import React, { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import {
  searchCollections,
  fetchCollectionContent,
  fetchAllAttachments,
  addTitle
} from '../../store/actions/navigation';
import './TableOfContents.scss';
import Spinner from '../common/Spinner';
import { Button } from 'react-bootstrap';
import { groupedByFilters, allSections } from '../../common/filters';
import ReactGA from 'react-ga';
import ShowAttachment from './ShowAttachment';
import debounce from 'lodash/debounce';

/* eslint-disable react/prop-types */
export const TableOfContents = props => {
  const [expand, setExpand] = useState();
  const [filtered, setFiltered] = useState({});
  const [searchText, setSearchText] = useState('');
  const [searchLength, setSearchLength] = useState(0);
  const {
    searchCollections,
    fetchCollectionContent,
    fetchAllAttachments,
    addTitle
  } = props;

  let filteredTypes = [];
  let filteredSections = [];
  const getActiveFilters = useCallback(() => {
    const active = document.getElementsByClassName('active-button');
    for (let i = 0; i < active.length; i++) {
      if (
        active[i].innerText === 'Tabeller' ||
        active[i].innerText === 'Figurer'
      ) {
        filteredTypes.push(
          active[i].innerText === 'Tabeller' ? 'TABLE' : 'FIGURE'
        );
      } else {
        filteredSections.push(active[i].innerText);
      }
    }
  }, [filteredSections, filteredTypes]);

  useEffect(() => {
    fetchCollectionContent(props.match.params);
  }, [props.match.params, fetchCollectionContent]);

  useEffect(() => {
    if (props.contents && props.contents.id) {
      fetchAllAttachments(props.contents.id);
    }
  }, [fetchAllAttachments, props.contents]);

  useEffect(() => {
    if (props.match.params) {
      searchCollections(props.match.params, searchText);
    }
  }, [searchCollections, props.match.params, searchText]);

  useEffect(() => {
    if (props.contentSearch && props.contentSearch.length >= 0) {
      getActiveFilters();
      setFiltered(
        groupedByFilters(props.contentSearch, filteredTypes, filteredSections)
      );

      const urlParams = new URLSearchParams(props.location.search);
      const showView = urlParams.get('visning');
      if (showView === 'tabeller') {
        document.getElementById('table-button').click();
      } else if (showView === 'figurer') {
        document.getElementById('figure-button').click();
      }
    } // eslint-disable-next-line
  }, [props.contentSearch, props.location.search]);

  let buttons;
  let sections = allSections(props.attachments);
  buttons = Object.keys(sections).map((section, index) => {
    if (section !== 'null') {
      return (
        <Button
          className="sorting-button"
          key={index}
          onClick={e => {
            ReactGA.event({
              category: `${props.contents.shortName} ' ' ${props.contents.year}`,
              action: 'Section filter clicked',
              label: section
            });
            filterView(e);
          }}
        >
          {section}
        </Button>
      );
    }
    return null;
  });

  const filterView = event => {
    setActiveClass(event);
    getActiveFilters();
    setFiltered(
      groupedByFilters(props.contentSearch, filteredTypes, filteredSections)
    );
  };

  const setActiveClass = event => {
    event.target.classList.contains('active-button')
      ? event.target.classList.remove('active-button')
      : event.target.classList.add('active-button');
  };

  addTitle(
    `${props.contents && props.contents.name}
    ${props.contents && props.contents.year}`
  );

  const searchHandler = debounce(text => {
    setSearchText(text);
  }, 250);

  return (
    <React.Fragment>
      <div className="flex-container top-align text-left flex-column">
        <div>
          <Button
            id="table-button"
            className="sorting-button"
            onClick={e => {
              ReactGA.event({
                category: `${props.contents.shortName} ' ' ${props.contents.year}`,
                action: 'Main filter clicked',
                label: 'Tables'
              });
              filterView(e);
            }}
          >
            Tabeller
          </Button>
          <Button
            id="figure-button"
            className="sorting-button"
            onClick={e => {
              ReactGA.event({
                category: `${props.contents.shortName} ' ' ${props.contents.year}`,
                action: 'Main filter clicked',
                label: 'Figures'
              });
              filterView(e);
            }}
          >
            Figurer
          </Button>
        </div>
        <div>{buttons}</div>

        <div className="sorting-heading">Søk i vedlegg</div>
        <div className="sorting-search-input">
          <input
            id="search-input"
            className="search-input"
            type="search"
            placeholder="Søk"
            onChange={event => {
              searchHandler(event.target.value);
              setSearchLength(event.target.value.length);
            }}
            onBlur={ev => {
              ReactGA.event({
                category: `${props.contents.shortName} ' ' ${props.contents.year}`,
                action: 'Searching',
                label: searchText
              });
            }}
          />
          {
            <div
              className={searchLength > 0 ? 'search-icon clear' : 'search-icon'}
              onClick={event => {
                if (searchLength > 0) {
                  searchHandler('');
                  document.getElementById('search-input').value = '';
                  setSearchLength(0);
                }
              }}
            ></div>
          }
        </div>

        <nav className="tableOfContents mt-4">
          {filtered ? (
            Object.keys(filtered).map((section, sectionIndex) => (
              <div key={sectionIndex} className="list-container">
                {section !== 'null' && <h5>{section}</h5>}
                {filtered[section].map((item, typeIndex) => (
                  <div key={typeIndex}>
                    <button
                      onClick={() => {
                        ReactGA.event({
                          category: `${props.contents.shortName}' '${props.contents.year}`,
                          action: 'Expand attachment',
                          label: `${item.attachmentType} ' ' ${item.label}  ' ' ${item.name}`
                        });
                        setExpand(
                          `${sectionIndex}${typeIndex}` === expand
                            ? ''
                            : `${sectionIndex}${typeIndex}`
                        );
                      }}
                    >
                      {item.attachmentType === 'FIGURE' ? 'Figur' : 'Tabell'}{' '}
                      {item.label} {item.name}
                    </button>
                    <ShowAttachment
                      test={`${sectionIndex}${typeIndex}`}
                      content={props.contents}
                      item={item}
                      expanded={expand === `${sectionIndex}${typeIndex}`}
                    />
                  </div>
                ))}
              </div>
            ))
          ) : (
            <Spinner />
          )}
        </nav>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = state => {
  return {
    contentSearch: state.navigation.contents,
    contents: state.navigation.collection,
    attachments: state.navigation.attachments
  };
};
export default connect(mapStateToProps, {
  searchCollections,
  fetchCollectionContent,
  fetchAllAttachments,
  addTitle
})(TableOfContents);
